import React from 'react';
import { metrics } from '../data/content';
export function MetricsSection() {
  return <section aria-labelledby="metricas" className="border-y border-ink-600 bg-ink-800" data-id="element-132" data-mp="39t7brqgjb6ic">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-16" style={{
      paddingTop: "9px",
      paddingBottom: "8px"
    }} data-id="element-133" data-mp="34tujurat398w">
        <h2 id="metricas" className="text-center font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-134" data-mp="2zv9ksv7aivm1">
          Los números hablan
        </h2>

        <dl className="mt-10 grid gap-px overflow-hidden rounded-2xl border border-ink-500 bg-ink-500 sm:grid-cols-2 lg:grid-cols-5" data-id="element-135" data-mp="1ccf4sqbyicp">
          {metrics.map((metric, index) => <div key={metric.label} className="flex flex-col justify-between bg-ink-900 p-6 text-center" data-id="element-136" data-mp="3nrnez7f6uevq" data-mpi={index}>
              <dd className={`font-display leading-none ${index === 4 ? 'text-xl sm:text-2xl' : 'text-4xl sm:text-5xl'} ${index === 3 ? 'text-ball-400' : 'text-white'}`} data-id="element-137" data-mp="3isubm7tm849a">
                {index === 3 ? `⭐ ${metric.value}` : metric.value}
              </dd>
              <dt className="mt-4 text-xs font-semibold uppercase tracking-[0.15em] text-slate-400" data-id="element-138" data-mp="3jwxqhecyjhe5">
                {metric.label}
              </dt>
            </div>)}
        </dl>
      </div>
    </section>;
}